"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopularCityClickViewDetailsSuccessEvent = exports.PopularCityClickBookmarkSuccessEvent = exports.PopularCityClickPleaseSubmitSuccessEvent = exports.PopularCityRecommendJobsSuccessEvent = exports.PopularCityClickMatchedCitySuccessEvent = exports.PopularCityRecommendCitiesSuccessEvent = exports.PopularCityLandingSuccessEvent = void 0;
const base_event_1 = require("./base.event");
class PopularCityLandingSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_LANDING_SUCCESS';
    }
}
exports.PopularCityLandingSuccessEvent = PopularCityLandingSuccessEvent;
class PopularCityRecommendCitiesSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_RECOMMEND_CITIES_SUCCESS';
    }
}
exports.PopularCityRecommendCitiesSuccessEvent = PopularCityRecommendCitiesSuccessEvent;
class PopularCityClickMatchedCitySuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_CLICK_MATCHED_CITY_SUCCESS';
    }
}
exports.PopularCityClickMatchedCitySuccessEvent = PopularCityClickMatchedCitySuccessEvent;
class PopularCityRecommendJobsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_RECOMMEND_JOBS_SUCCESS';
    }
}
exports.PopularCityRecommendJobsSuccessEvent = PopularCityRecommendJobsSuccessEvent;
class PopularCityClickPleaseSubmitSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_CLICK_PLEASE_SUBMIT_SUCCESS';
    }
}
exports.PopularCityClickPleaseSubmitSuccessEvent = PopularCityClickPleaseSubmitSuccessEvent;
class PopularCityClickBookmarkSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_CLICK_BOOKMARK_SUCCESS';
    }
}
exports.PopularCityClickBookmarkSuccessEvent = PopularCityClickBookmarkSuccessEvent;
class PopularCityClickViewDetailsSuccessEvent extends base_event_1.BaseEvent {
    constructor() {
        super(...arguments);
        this.type = 'POPULAR_CITY_CLICK_VIEW_DETAILS_SUCCESS';
    }
}
exports.PopularCityClickViewDetailsSuccessEvent = PopularCityClickViewDetailsSuccessEvent;
//# sourceMappingURL=popular-city.events.js.map